import Highcharts from 'highcharts';

if (Highcharts.seriesTypes.treemap) {
   Highcharts.seriesTypes.treemap.prototype.squarifiedEUT = function (parent, children) {
      function sum(row) {
      return row.reduce(function (acc, val) {
          return acc + val;
        }, 0)
      }

      function worst(s, min, max, w) {
      var w2 = w * w, s2 = s * s;
      return Math.max(w2 * max / s2, s2 / w2 / min);
      }

      function dump(row, x, y, z) {
      row.forEach(function (weight) {
        var d = weight / z;
        if (vertical) {
          childrenAreas.push({ x: x, y: y, width: z, height: d });
          y += d;
        } else {
          childrenAreas.push({ x: x, y: y, width: d, height: z });
          x += d;
        }
      });
      return z;
      }

      var x = parent.x, y = parent.y, rw = parent.width, rh = parent.height,
        scale = (rw * rh) / parent.val, vertical = rh < rw,
        w = vertical ? rh : rw,
        row = [], childrenAreas = [];

      children.forEach(function (child) {
      var r = scale * child.val;

      if (row.length == 0) {
        row.push(r);
        return;
      }

      var s = sum(row), min = Math.min.apply(Math, row), max = Math.max.apply(Math, row),
        wit = worst(s + r, Math.min(min, r), Math.max(max, r), w),
        wio = worst(s, min, max, w);

      if (wit < wio) {
        row.push(r);
        return;
      }

      var z = dump(row, x, y, s / w);

      if (vertical) {
        x += z; rw -= z;
      } else {
        y += z; rh -= z;
      }

      vertical = rh < rw;
      w = vertical ? rh : rw;
      row = [r];
      });

      dump(row, x, y, sum(row) / w);

      return childrenAreas;
   };
}